'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useReducer, } from 'react';
var ActionType;
(function (ActionType) {
    ActionType[ActionType["CHECKS_UPDATED"] = 0] = "CHECKS_UPDATED";
    ActionType[ActionType["CHECK_CREATED"] = 1] = "CHECK_CREATED";
    ActionType[ActionType["CHECK_REMOVED"] = 2] = "CHECK_REMOVED";
})(ActionType || (ActionType = {}));
const reducer = (state, action) => {
    switch (action.type) {
        case ActionType.CHECKS_UPDATED: {
            return [...action.data];
        }
        case ActionType.CHECK_CREATED: {
            return [...state, action.data];
        }
        case ActionType.CHECK_REMOVED: {
            return state.filter(({ id }) => id !== action.data.id);
        }
    }
};
const initialState = [];
const CheckersContext = createContext(null);
const CheckersProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const toggleCheck = useCallback((id) => {
        const data = { id };
        const exists = state.findIndex((checked) => checked.id === id) > -1;
        if (exists) {
            dispatch({ type: ActionType.CHECK_REMOVED, data });
        }
        else {
            dispatch({ type: ActionType.CHECK_CREATED, data });
        }
    }, [dispatch, state]);
    const updateChecks = useCallback((data) => {
        dispatch({ type: ActionType.CHECKS_UPDATED, data });
    }, []);
    const removeChecked = useCallback((cb) => {
        for (const checked of state) {
            cb(checked.id);
            dispatch({ type: ActionType.CHECK_REMOVED, data: { id: checked.id } });
        }
    }, [dispatch, state]);
    const checked = useCallback((id) => state.findIndex((checked) => checked.id === id) > -1, [state]);
    const value = {
        checks: state,
        removeChecked,
        toggleCheck,
        checked,
        updateChecks,
    };
    return (_jsx(CheckersContext.Provider, { value: value, children: children }));
};
function useCheckers() {
    const context = useContext(CheckersContext);
    if (!context)
        throw new Error('useCheckers requires a context!');
    return context;
}
export { CheckersProvider, useCheckers };
//# sourceMappingURL=checkers.js.map